import { useContext, useEffect, useMemo, useState } from 'react'

import { SocketContext } from '../../../context/SocketContext'

import { SelectElement } from '../../../components/selectElement2'
import LoadingOverlay from '../../../components/LoadingOverlay';
import { serverApi } from '../../../api';
import { getUsuarioStorage } from '../../../helpers/getUsuarioStorage';


const chipStyle = {
    background: '#f1f5f9', color: '#475569', fontWeight: 700,
    padding: '5px 11px', borderRadius: 999, fontSize: 12,
    display: 'inline-flex', alignItems: 'center', gap: 5,
    whiteSpace: 'nowrap', lineHeight: 1.4,
};

const chipOk = { background: '#d1fae5', color: '#047857' };
const chipNo = { background: '#e2e8f0', color: '#64748b' };


export const UsuariosRoles = () => {

    const { socket } = useContext(SocketContext);
    const usuario = useMemo(() => getUsuarioStorage(), []);

    const [isLoading, setIsLoading] = useState(false);
    const [usuarios, setUsuarios] = useState([]);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'eol',
        sortDir: 'asc',
        ubicacion: '',
        codigoUbicacion: '',
        uidUsuario: ''
    });

    // tabla
    const [data, setData] = useState([]);
    const [buscar, setBuscar] = useState('');

    //Select Usuarios
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");
        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/usuarios/select-usuarios`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.uidUsuario, label: item.nombreCompleto.toUpperCase() }))
                setUsuarios(opciones);


            } catch (error) {
                console.error("Error al obtener los usuarios", error);
            } finally {

            }
        };

        fetch();

    }, [])


    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            if (Array.isArray(lista)) setData(lista);
        };

        socket.on('lista-usuario-roles', handler);

        return () => {
            socket.off('lista-usuario-roles', handler);
        };



    }, [socket]);

    useEffect(() => {

        const codigoEntidad = usuario.codigoEntidad
        // const codigoUbicacion = usuario.codigoUbicacion

        if (!codigoEntidad) return;

        const load = async () => {
            try {

                setIsLoading(true);

                const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;


                const resp = await serverApi.post(
                    `/usuarios/usuario-roles`,
                    {
                        ...query,
                        codigoEntidad,
                        codigoUbicacion
                    }
                );


                setData(resp.data.data || []);

            } catch (error) {
                console.error("Error al obtener roles del usuario", error);
            } finally {
                setIsLoading(false);
            }
        };

        load();

    }, [query, usuario.codigoUbicacion, usuario.codigoEntidad]);


    const handleChecked = async (seleccion) => {

        const uidRol = seleccion.target.id;
        const checked = seleccion.target.checked;
        if (query.uidUsuario === "") return;

        // Actualización optimista
        setData(prev => prev.map(it => it.uidRol === uidRol ? { ...it, checked } : it));

        try {

            setIsLoading(true);

            const codigoEntidad = usuario.codigoEntidad;
            if (codigoEntidad === "") return;
            const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

            await serverApi.post(
                `/usuarios/edita-usuario-rol`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    uidRol,
                    checked
                }
            );

        } catch (error) {
            console.error("Error al editar rol del usuario", error);
            // Revertir
            setData(prev => prev.map(it => it.uidRol === uidRol ? { ...it, checked: !checked } : it));
        } finally {
            setIsLoading(false);
        }


    }

    const handleSelectUsuario = (selected) => {
        setQuery(prev => ({
            ...prev,
            uidUsuario: selected.value,
        }));
        setBuscar('');
    };

    const total = data.length;
    const asignados = data.filter(r => r.checked).length;
    const visibles = data.filter(r => (r.rol || '').toLowerCase().includes(buscar.trim().toLowerCase()));

    return (
        <>
            {isLoading && <LoadingOverlay />}

            <div style={{
                background: 'white', borderRadius: 16, overflow: 'hidden',
                boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0',
                fontFamily: "'Inter', Arial, sans-serif",
            }}>

                {/* Header de la card */}
                <div style={{
                    padding: '20px 26px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                    display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'space-between', alignItems: 'center',
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 46, height: 46, borderRadius: 14,
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                            color: 'var(--color-marca-contraste)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20, boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                        }}>
                            <i className="fa-solid fa-user-tag"></i>
                        </div>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18, color: '#0f172a' }}>Asignación de roles</h4>
                            <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#64748b' }}>
                                Asigna los roles disponibles a cada usuario
                            </p>
                        </div>
                    </div>

                    {query.uidUsuario && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                            <span style={{ ...chipStyle, ...chipOk }}>
                                <i className="fa-solid fa-circle-check"></i> Asignados: <b>{asignados}</b>
                            </span>
                            <span style={chipStyle}>
                                <i className="fa-solid fa-shield-halved"></i> Total: <b>{total}</b>
                            </span>
                        </div>
                    )}
                </div>

                {/* Barra de herramientas */}
                <div style={{
                    padding: '16px 26px', borderBottom: '1px solid #f1f5f9',
                    display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'flex-end', justifyContent: 'space-between',
                }}>
                    <div style={{ width: 380, maxWidth: '100%' }}>
                        <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                            Usuario
                        </label>
                        <SelectElement
                            options={usuarios}
                            name={"uidUsuario"}
                            isMulti={false}
                            closeOnMenuSelect={true}
                            value={usuarios.find(u => u.value === query.uidUsuario)}
                            onChange={(selected) => handleSelectUsuario(selected)}
                            classname=""
                            isClearable={false}
                            fontSize="13.5px"
                        />
                    </div>

                    {query.uidUsuario && (
                        <div style={{ position: 'relative', flex: 1, maxWidth: 300, minWidth: 200 }}>
                            <i className="fa-solid fa-magnifying-glass" style={{
                                position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)',
                                color: '#94a3b8', fontSize: 13,
                            }} />
                            <input
                                type='text'
                                placeholder='Filtrar roles...'
                                value={buscar}
                                onChange={(ev) => setBuscar(ev.target.value)}
                                style={{
                                    width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                    border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                    background: '#f8fafc',
                                }}
                                onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                            />
                        </div>
                    )}
                </div>

                {/* Lista de roles */}
                <div style={{ padding: '18px 26px', background: '#f8fafc' }}>
                    {!query.uidUsuario ? (
                        <div style={{ padding: '48px 20px', textAlign: 'center' }}>
                            <div style={{ color: '#94a3b8', fontSize: 34, marginBottom: 8 }}>
                                <i className="fa-solid fa-user-tag"></i>
                            </div>
                            <div style={{ fontWeight: 700, color: '#64748b', fontSize: 15 }}>
                                Selecciona un usuario
                            </div>
                            <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>
                                Elige un usuario para asignarle sus roles.
                            </div>
                        </div>
                    ) : visibles.length === 0 ? (
                        <div style={{ padding: '40px 20px', textAlign: 'center' }}>
                            <div style={{ color: '#94a3b8', fontSize: 30, marginBottom: 8 }}>
                                <i className="fa-solid fa-shield-halved"></i>
                            </div>
                            <div style={{ fontWeight: 700, color: '#64748b', fontSize: 14 }}>
                                No hay roles que coincidan con el filtro
                            </div>
                        </div>
                    ) : (
                        <div style={{ maxHeight: 460, overflowY: 'auto', paddingRight: 2 }}>
                            {visibles.map((item) => (
                                <div
                                    key={item.uidRol}
                                    style={{
                                        display: 'flex', alignItems: 'center', gap: 14,
                                        background: 'white', borderRadius: 12,
                                        border: `1.5px solid ${item.checked ? 'var(--color-primario-borde)' : '#e2e8f0'}`,
                                        padding: '12px 16px', marginBottom: 10,
                                    }}
                                >
                                    <div style={{
                                        width: 38, height: 38, borderRadius: 10, flexShrink: 0,
                                        background: item.checked ? 'rgba(var(--color-primario-rgb), 0.12)' : '#f1f5f9',
                                        color: item.checked ? 'var(--color-primario)' : '#94a3b8',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
                                    }}>
                                        <i className="fa-solid fa-shield-halved"></i>
                                    </div>

                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 14 }}>
                                            {(item.rol || '').toUpperCase()}
                                        </div>
                                        <div style={{ color: '#64748b', fontSize: 12, marginTop: 1 }}>
                                            Rol del sistema
                                        </div>
                                    </div>

                                    <span style={item.checked ? { ...chipStyle, ...chipOk } : { ...chipStyle, ...chipNo }}>
                                        {item.checked ? <i className="fa-solid fa-check"></i> : <i className="fa-solid fa-minus"></i>}
                                        {item.checked ? 'Asignado' : 'No asignado'}
                                    </span>

                                    <input
                                        type="checkbox"
                                        checked={item.checked}
                                        id={`${item.uidRol}`}
                                        onChange={(seleccion) => handleChecked(seleccion)}
                                        style={{ width: 18, height: 18, accentColor: 'var(--color-primario)', cursor: 'pointer' }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
